import React from "react";

export default (props) => {
    const {handleMessage, chat_message, sending, submitSendMessage} = props;

    return (
        <form onSubmit={(e) => sending ? false : submitSendMessage(e)}>
            <div className="chat-content">
                <input
                    onChange={(e) => handleMessage(e.target.value)}
                    value={chat_message}
                    type="text"
                    placeholder="Введите сообщение"
                    className="width100 chat_message"
                    />
                <div className="small-button">
                    <button type="submit">{sending ? 'Отправляется': 'Отправить'}</button>
                </div>
            </div>
        </form>
    )
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Chat/SendMessage.js